import type { FC } from 'react';
import { NavigationControl as RawNavigationControl } from 'react-map-gl';

export const NavigationControl: FC = () => {
  return <RawNavigationControl style={{ position: 'unset' }} />;
};
